import {GET_VOTE_REMAIN_TIMES, SIGN_FOR_VOTE, GET_VOTE_CHAR_LIST, VOTE_FOR_CHAR} from '../constant/eventbus'
import {getJSON} from '../api/myaxios'
import {error_event} from "../tools/mgtv/analysis";
import preload from "../tools/preload";
import {isFunction} from '../tools/typeof'

//vote remain times
function fetch_vote_remain_times() {
  getJSON('//vipact3.api.mgtv.com/api/v1/act/vote/userinfo', {
    act_name: window.rootdata.act_name,
    ticket: window.$bus.user.ticket
  }).then(res => {
    if (!res) {
      return;
    }
    if (res.ret === 0) {
      if (res.data.user_info) {
        window.$bus.vote.remain_times = res.data.user_info.remain_vote_num;
      }
    } else {
      $toast(res.msg || "获取剩余票数失败")
    }
  }).catch(e => {
    error_event(e, 'fetch_vote_remain_times');
    $toast("获取剩余票数异常");
  });
}


function vote_sign() { //签到
  getJSON('//vipact3.api.mgtv.com/api/v1/act/vote/sign', {
    act_name: rootdata.act_name,
    ticket: $bus.user.ticket
  }).then(resp => {
    if (resp.ret === 0) {
      window.$bus.$emit(GET_VOTE_REMAIN_TIMES); //刷新票数

    }
  })
}


function get_charlist() { //候选人信息
  getJSON('//vipact3.api.mgtv.com/api/v1/act/vote/charlist', {
    act_name: rootdata.act_name
  }).then(res => {
    if (!res) {
      return;
    }
    if (res.ret === 0) {
      window.$bus.vote.character_list = res.data.character_list;
    } else {
      $toast(res.msg || "获取投票候选人失败");
    }
  }).catch(error => {
    $toast("获取投票候选人异常");
    error_event(error, 'get_charlist')
  });
}


function get_char_by_id(id) {

  if (!window.$bus.vote.character_list) {
    return null;
  }

  return window.$bus.vote.character_list.find(item => {
    console.log(id, item.char_id)
    return item.char_id === id;
  })
}


export function vote(char_id, vote_num,succ_cb) {
  if (vote_num <= 0) {
    return;
  }
  if (!window.$bus.user.ticket) {
    return
  }
  getJSON('//vipact3.api.mgtv.com/api/v1/act/vote/vote', {
    act_name: window.rootdata.act_name,
    ticket: window.$bus.user.ticket,
    char_id: char_id,
    vote_num: vote_num || 1
  }).then(resp => {
    if (!resp) {
      return;
    }
    if (resp.ret === 0) {

      //减少自己的票数
      window.$bus.vote.remain_times -= vote_num;

      //直接操作event_bus，增加被投票人的票数
      const char_obj = get_char_by_id(char_id);
      console.log('char_obj', char_obj)
      if (char_obj) {
        char_obj.vote_num += vote_num;
      }
    }
    if(succ_cb){
      succ_cb()
    }else{
      window.$toast("投票成功!");
    }
    // else if (resp.ret === 2081) { //no_times
    //   $toast(resp.msg || "没有票啦")
    // } else {
    //   $toast(resp.msg || "投票失败")
    // }
  }).catch(error => {
    $toast("投票失败")
    error_event(error, 'handleVote')
  })
}

export default {
  install: function (EventBus) {

    //获取候选人信息
    EventBus.$on(GET_VOTE_CHAR_LIST, () => {
      get_charlist();
    });

    //获取剩余票数
    EventBus.$on(GET_VOTE_REMAIN_TIMES, () => {
      if (!window.$bus.user.uuid) {
        return;
      }
      fetch_vote_remain_times();
    });

    //签到送票
    EventBus.$on(SIGN_FOR_VOTE, () => {
      if (!window.$bus.user.uuid) {
        return;
      }
      vote_sign();
    });

    //投票
    EventBus.$on(VOTE_FOR_CHAR, (char_id, vote_num,succ_cb) => {
      vote(char_id, vote_num,succ_cb);
    })

  }


}





// WEBPACK FOOTER //
// ./src/EventBus/EventVote.js